// Central site configuration — easy to update assets, links and contact info
// without touching individual components.

export const LOGO_LIFETALK_RADIO =
  "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/26k99fn7_Life%20talk%20trust%20and%20Life%20talk%20ratio%20station%20logo.jpeg";

export const LOGO_FATHERS_HOUSE =
  "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/9rg43f0d_Father%27s%20House%20church%20Logo.jpg";

// Social links
export const LINK_RADIO_FB =
  "https://www.facebook.com/lifetalktga?mibextid=ZbWKwL";
export const LINK_CHURCH_FB =
  "https://www.facebook.com/share/1FSMg7iraa/";
export const LINK_CHURCH_YT =
  "https://youtube.com/@fathershousetauranga?si=UFD6M9-O-vfr-0SM";
export const LINK_RADIO_YT =
  "https://youtube.com/@lifetalk4886?si=WnqTeSammnEC6MUv";
export const LINK_CHURCH_IG =
  "https://www.instagram.com/fathershouse_tga?igsh=MTU5d2IyZ2gwejBqcA==";

// ---------------------------------------------------------------------------
// Contact — pastors lead both ministries, so we expose both email domains
// (Life Talk Trust + Father's House Church) and both official numbers.
// ---------------------------------------------------------------------------
export const CONTACT_PHONES = ["+64 21 176 3058", "+64 210 838 3775"];

export const EMAILS_LIFETALK = [
  "robinsonmartin@lifetalkofficial.com",
  "esthermartin@lifetalkofficial.com",
];

export const EMAILS_FATHERS_HOUSE = [
  "robinsonmartin@fathershousetga.co.nz",
  "esthermartin@fathershousetga.co.nz",
];

// Primary contact (used by mailto / wa.me helpers + legacy references).
export const CONTACT_WHATSAPP = CONTACT_PHONES[0];
export const CONTACT_EMAIL = EMAILS_LIFETALK[0];

// Brand tagline
export const TAGLINE = "Bringing life into your world";

// FM broadcast areas — order preserved
export const FM_FREQUENCIES = [
  { freq: "88.3 FM", region: "Tauranga" },
  { freq: "87.6 FM", region: "Te Puke" },
  { freq: "87.6 FM", region: "Whakatāne" },
  { freq: "87.7 FM", region: "Rotorua" },
  { freq: "87.6 FM", region: "Hamilton" },
  { freq: "87.8 FM", region: "Katikati" },
  { freq: "87.9 FM", region: "Pukekohe" },
];

// Church
export const CHURCH_NAME = "Father's House Indian Church Tauranga";
export const CHURCH_TAGLINE = "A place for everyone";
export const CHURCH_ADDRESS =
  "130 Spring Street, Tauranga 3110, New Zealand";
export const CHURCH_SERVICE_TIME = "Every Sunday · 4:00 PM – 6:00 PM";
export const MAP_LINK_CHURCH = "https://maps.app.goo.gl/ZKmJmwdUAKMkAdSX6";

// Radio office
export const RADIO_OFFICE_NAME = "Life Talk Radio Office";
export const RADIO_OFFICE_ADDRESS =
  "1064 State Highway 29, RD 1, Tauranga 3171, New Zealand";
export const MAP_LINK_RADIO = "https://maps.app.goo.gl/EQwLRxiVNTMzwRRUA";

// Helper for WhatsApp deep link (strips spaces and +)
const phoneToDigits = (p) => p.replace(/[^0-9]/g, "");
export const whatsappHref = `https://wa.me/${phoneToDigits(CONTACT_WHATSAPP)}`;
export const whatsappHrefFor = (phone) =>
  `https://wa.me/${phoneToDigits(phone)}`;
export const emailHref = `mailto:${CONTACT_EMAIL}`;
